module.exports = __webpack_public_path__ + "img/WebTitan.875edd71.svg";